import { render, staticRenderFns } from "./ShopDerate.vue?vue&type=template&id=2800c652&scoped=true&"
import script from "./ShopDerate.vue?vue&type=script&lang=js&"
export * from "./ShopDerate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2800c652",
  null
  
)

component.options.__file = "ShopDerate.vue"
export default component.exports